export default function darkModeManager(goDark, goLight) {
	window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
		event.matches ? goDark() : goLight();
	});
	if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
		goDark();
	} else {
		goLight();
	}
}